import {inject, Injectable} from "@angular/core";
import {HttpService} from "../http/httpservice.service";
import {AddressComponent, AddressValidationResult} from "../../models/types/address-types";
import {BehaviorSubject, debounce, debounceTime, filter, map, Observable, Subject, tap} from "rxjs";

@Injectable({
    providedIn: "root"
})
export class AddressService {
    private httpService = inject(HttpService);
    constructor() {}

    private showModal$ = new BehaviorSubject<boolean>(false);
    private addressResult$ = new BehaviorSubject<AddressValidationResult | null>(null);
    private responseId?: string | null = "";
    confirmedAddress$ = new Subject<AddressComponent>();
    showModal(results: AddressValidationResult) {
        this.showModal$.next(true);
        this.addressResult$.next(results);
    }

    hideModal() {
        this.showModal$.next(false);
    }

    getModalState() {
        return this.showModal$.asObservable();
    }
    getValidationResults() {
        return this.addressResult$.asObservable();
    }

    validateAddress(address: AddressComponent, fromModal: boolean = false) {
        return this.httpService
            .post<AddressValidationResult>("/api/lead/validateaddress/" + this.responseId, address)
            .pipe(
                tap((result) => {
                    if (!fromModal) {
                        result ? this.showModal(result) : result;
                    } else {
                        this.addressResult$.next(result);
                    }
                     this.responseId = result.responseId;
                })
            );
    }

    confirmUserAddressChoice(confirmedAddress?: AddressComponent | null) {
        if (confirmedAddress) {
            this.confirmedAddress$.next(confirmedAddress);
        }

        this.hideModal();
    }

    convertArrayToObject<T extends Record<string, any>>(array: T[], keyField: keyof T): Record<string, T> {
        return Object.fromEntries(array.map((item) => [String(item[keyField]), item]));
    }
}
